import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableRow,
} from '../Table/Table';
import { PackageCompatibilityTableProps } from './types';

export const PackageCompatibilityTable = ({
  unityVersion,
  renderPipelines,
  buildTarget,
  microcopy,
  className,
}: PackageCompatibilityTableProps) => {
  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>
      <TableBody variant="alternate">
        <TableRow>
          <TableCell>{microcopy.unityVersion}</TableCell>
          <TableCell className="break-normal">
            {unityVersion.join(', ')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{microcopy.renderPipelines}</TableCell>
          <TableCell>{renderPipelines.join(', ')}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{microcopy.buildTarget}</TableCell>
          <TableCell>{buildTarget.join(', ')}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
